import type { CSSProperties, HTMLAttributes } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

interface IProps extends HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string;
}

export const DraggableRow = ({ style, ...rest }: Readonly<IProps>) => {
  const { setNodeRef, transform, transition, isDragging } = useSortable({
    id: rest['data-row-key'],
  });

  const rowStyles: CSSProperties = {
    ...style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  return (
    <tr
      {...rest}
      ref={setNodeRef}
      style={rowStyles}
    />
  );
};
